export const defaultSubjectData: any = {
  id: '',
  name: '',
  region: '',
  isActive: false
}
